module.exports = __webpack_public_path__ + "static/media/IMG_1518.35c3a1c9.jpg";